// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".catalog-tip-dialog{text-align:center;white-space:nowrap;overflow:auto}.catalog-tip-dialog:after{content:\"\";display:inline-block;vertical-align:middle;height:100%}.catalog-tip-dialog .el-dialog{margin:30px auto!important;display:inline-block;vertical-align:middle;text-align:center;white-space:normal}", ""]);
// Exports
module.exports = exports;
